import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";

const WdsfAthlete = ({ person, t }) => (
    <Box>
        <List dense>
            <ListItem>
                <ListItemText primary={`${person.surname}, ${person.name}`} secondary={t("reg.name")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${person.ageGroup}`} secondary={t("reg.age_group")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${person.country}`} secondary={t("reg.country")} />
            </ListItem>
        </List>
    </Box>
);

export default WdsfAthlete;
